/***
 * Created on 2023/8/16
 * @author: Adam Cheng <adamcheng@qnap.com>
 ***/
import React from 'react';
import ModalDialog from "../../common/modal_dialog/modalDialog";
import {useTranslation} from "react-i18next";
import {useMutation, useQueryClient} from "@tanstack/react-query";
import {apiDelete} from "../../../service/api";

function DeleteAccessDialog(props) {
    const { t } = useTranslation();
    const queryClient = useQueryClient();

    const removeMutation = useMutation({
        mutationFn: async (data) => await apiDelete(`/ajax/remote_login_user`, data),
        onSuccess: data => {
            queryClient.invalidateQueries({
                queryKey: ['get_remote_login_user']
            })
        },
        onError: (error, variables, context) => {
            console.error(error);
        }
    });

    const onClick = async () => {
        await removeMutation.mutateAsync({
            access_token: props?.metadata?.access_token,
            token_id: props?.metadata?._id
        });
    }

    return (
        <ModalDialog {...props} title={t('@Remove access@')} submitText={t('@Yes@')} submitAction={onClick}>
            <div className="dialog-content">
                {
                    props?.metadata?.type === 'mobile' &&
                    <p>{t('@Your device will sign out QID automatically once you remove access.@')}</p>
                }

                {
                    props?.metadata?.type === 'nas' &&
                    <p>{t('@Once you remove access for a QNAP device, it will no longer be able to access the myQNAPcloud service. However, CloudLink remote session will still remain but no longer than 24 hours. If you would like to stop all myQNAPcloud service immediately, we recommend unregistering device in Device detail.@')}</p>
                }

                {
                    !['mobile', 'nas'].includes(props?.metadata?.type) &&
                    <p>{t('@Your device will automatically sign out QID once you remove access. You might need to remove this device from browser notification settings if you have it enabled.@')}</p>
                }

                {t('@Are you sure that you want to remove access?@')}
            </div>

        </ModalDialog>
    );
}

export default DeleteAccessDialog;